'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'MainCtrl', [ '$rootScope', 'lodash', '$state', '$sessionStorage', '$location', '$window', '$timeout', 'notificationService', 'invite', function ( $rootScope, _, $state, $sessionStorage, $location, $window, $timeout, notificationService, invite ) {
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;
        /**
         * Setting this here so we can use it in subsequent call in the
         * same session. If they verify again, it will get the latest data.
         * Otherwise, we can safely reuse their initial request for the invite.
         */
        _.set( $sessionStorage, 'invitation', invite );
        /**
         * On every reload, we want to clear out email validation check and send them
         * to the main route if they are not already there.
         */
        _.set( $rootScope, 'RSVPEmailVerified', false );

        // Decrypt invitation so we can set the header image.
        var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

        /**
         * Set the banner image for all pages.
         */
        if ( invitation ) {
            _.set( $rootScope, 'rsvp', _.get( invitation, 'rsvp' ) );

            // Set the header banner
            $rootScope.setHeaderBanner( invitation );
            $rootScope.setSupportInfo( invitation );

            // set theme colors before any redirection
            // Hack for old groups
            if ( _.get( invitation, 'experienceID.RSVPCustomization.primaryColor' ) && !_.has( invitation, 'experienceID.RSVPCustomization.acceptButtonColor' ) ) {
                _.set( invitation, 'experienceID.RSVPCustomization.acceptButtonColor', _.get( invitation, 'experienceID.RSVPCustomization.primaryColor' ) );
                _.set( invitation, 'experienceID.RSVPCustomization.primaryColor', '#002D72' );
            }
            if ( _.get( invitation, 'experienceID.RSVPCustomization.secondaryColor' ) && !_.has( invitation, 'experienceID.RSVPCustomization.declineButtonColor' ) ) {
                _.set( invitation, 'experienceID.RSVPCustomization.declineButtonColor', _.get( invitation, 'experienceID.RSVPCustomization.secondaryColor' ) );
                _.set( invitation, 'experienceID.RSVPCustomization.secondaryColor', '#A50050' );
            }
            _.set( $rootScope, 'theme.primaryColor', _.get( invitation, 'experienceID.RSVPCustomization.acceptButtonColor' ) );
            _.set( $rootScope, 'theme.secondaryColor', _.get( invitation, 'experienceID.RSVPCustomization.secondaryColor' ) );
            _.set( $rootScope, 'theme.acceptButtonColor', _.get( invitation, 'experienceID.RSVPCustomization.acceptButtonColor' ) );
            _.set( $rootScope, 'theme.declineButtonColor', _.get( invitation, 'experienceID.RSVPCustomization.declineButtonColor' ) );
            var font = _.get( invitation, 'experienceID.RSVPCustomization.font' );
            if ( font && font.family ) {
                var styleTag = document.createElement( 'link' );
                styleTag.rel = 'stylesheet';
                styleTag.type = 'text/css';
                styleTag.href = 'https://fonts.googleapis.com/css?family=' + font.value;
                document.getElementsByTagName( 'head' )[0].appendChild( styleTag );
                _.set( $rootScope, 'theme.font', font.family );
            }

            /**
             * Company Logo Setup
             */
            // ribyt logo default
            _.set( $rootScope, 'ribytLogo', 'images/concierge-logo-white-small.svg' );
            // set client admin company logo override if exists
            if ( _.has( invitation, 'companyLogo' ) ) {
                _.set( $rootScope, 'companyLogo', $rootScope.AWS.prefix + _.get( invitation, 'companyLogo' ).awsPath );
            }
            // set client admin sms opt in text overrides if they exist
            _.set( $rootScope, 'smsOptInOutDesc', _.get( invitation, 'smsOptInOutDesc' ) );
            _.set( $rootScope, 'smsOptInText', _.get( invitation, 'smsOptInText' ) );
            _.set( $rootScope, 'smsOptOutText', _.get( invitation, 'smsOptOutText' ) );
        }

        /**
         * Check if they passed the rsvpStatus param. If they did, then we have to
         * either bypass the welcome screen or pass them directly to the end.
         */
        if ( _.get( $rootScope, 'parameters.rsvpStatus' ) && !_.get( $rootScope, 'rsvpProcess' ) ) {
            if ( _.get( $rootScope, 'parameters.rsvpStatus' ) === 'y' ) {
                // Bring them to the guest info page
                if ( _.get( $rootScope, 'parameters.rsvpSkip' ) && ( !invitation.experienceID.RSVPDetails.isExperiencePassword || $rootScope.passwordAccepted ) && !$rootScope.isHasCompanions( invitation ) && !$rootScope.isHasLegals( invitation ) && $rootScope.getRequiredFields( _.get( invitation, 'experienceID.guestInformation.params' ), _.get( invitation, 'experienceID.guestInformation.paramsRequired' ) ).length === 0 ) {
                    return $rootScope.setRSVPToFinalYes( invitation );
                } else if ( !_.get( invitation, 'rsvpProcess' ) ) {
                    _.set( invitation, 'rsvpProcess', 'guestProfile' );
                    _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invitation ) );
                }
            } else if ( _.get( $rootScope, 'parameters.rsvpStatus' ) === 'n' && _.get( invitation, 'rsvp' ) !== 'y' ) {
                return $rootScope.decline( function decline ( err, resp ) {
                    if ( err && _.get( err, 'data.error_description' ) === 'This invite does not exist' ) {
                        // This error makes sense here if they refreshed.
                        return notificationService.error( 'Sorry but you have declined this event.' );
                    }

                    _.set( $sessionStorage, 'invitation', resp.data.data );
                    _.set( $rootScope, 'rsvp', 'n' );
                    invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

                    // Send them to the complete page
                    return $state.go( 'main.complete', {
                        'inviteHash': _.get( $rootScope, 'inviteHash', null )
                    }, { 'reload': true } );
                } );
            }
        }

        // Set current tab
        _.set( $rootScope, 'currentTab', _.get( invitation, 'rsvpProcess' ) );

        // get the day of the event.endDate
        var eventEndDate = _.get( invitation, 'eventID.dateEnd', '' ).substring( 0, _.get( invitation, 'eventID.dateEnd', '' ).indexOf( 'T' ) );
        if ( $rootScope.inviteNotFound ) {
            return $state.go( 'error', {
                'message': $rootScope.inviteNotFound,
                'inviteHash': _.get( $rootScope, 'inviteHash', null )
            } );
        } else if ( !invitation && _.get( $rootScope, 'inviteHashRedirect' ) ) {
            var inviteHash = _.get( $rootScope, 'inviteHashRedirect' );
            _.set( $rootScope, 'inviteHashRedirect', null );
            $location.search( 'inviteHash', inviteHash );
            $timeout( function () {
                if ( !$rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) ) ) {
                    $window.location.reload();
                }
            }, 1000 );
        } else if ( moment( eventEndDate ).add( 1, 'days' ).subtract( 1, 'seconds' ) < moment() && !$rootScope.parameters.showTicket ) {
            // show the error page if this is an expired invite up until midnight of that end date day
            return $state.go( 'error', {
                'message': 'This invite has expired. Please contact the host of this event for more information.',
                'inviteHash': _.get( $rootScope, 'inviteHash', null )
            } );
        } else if (
            ( _.get( invitation, 'rsvp' ) !== 'y' ) &&
            invitation.experienceID.RSVPDetails.displayEndDate &&
            ( moment.tz( invitation.experienceID.RSVPDetails.datetimeRegistrationClosed.split( '+' )[0], invitation.eventID.location.timezone ) < moment() ) &&
            !_.get( $rootScope, 'parameters.preview' )
        ) {
            return $state.go( 'error', {
                'message': invitation.experienceID.RSVPDetails.registrationClosedMessage,
                'inviteHash': _.get( $rootScope, 'inviteHash', null )
            } );
        } else if ( invitation ) {
            /**
             * Make sure the invite is not RSVP N
             */
            if ( _.includes( ['f'], _.get( invitation, 'rsvp', 'p' ) ) ) {
                $state.go( 'main.complete', { 'inviteHash': _.get( $rootScope, 'inviteHash', null ) } );
                return false;
            }

            /**
             * The only two variable we have to check right now are
             * legals and companions. Eventually we'll need payment.
             */
            _.set( $rootScope, 'hasLegalsRemaining', $rootScope.isHasLegals( invitation ) );
            _.set( $rootScope, 'hasLegals', $rootScope.isHasLegals( invitation ) );

            _.set( $rootScope, 'hasCompanionsRemaining', $rootScope.isHasCompanionsRemaining( invitation ) );
            _.set( $rootScope, 'hasCompanions', $rootScope.isHasCompanions( invitation ) );

            // Setup for tabs list. This should include all tabs.
            var tmpTabs = [{
                'tab': 'permission',
                'aria': 'permission',
                'name': 'Login',
                'display': invitation.experienceID.RSVPDetails.isExperiencePassword
            }, {
                'tab': 'introduction',
                'aria': 'introduction',
                'name': invitation.experienceID.landingPageCustomization && invitation.experienceID.landingPageCustomization.enabled ? invitation.experienceID.landingPageCustomization.tabName : 'RSVP Response',
                'display': invitation.experienceID.landingPageCustomization ? invitation.experienceID.landingPageCustomization.enabled : true
            }, {
                'tab': 'guestProfile',
                'aria': 'guestProfile',
                'name': 'Guest Profile',
                'display': true
            }, {
                'tab': 'legalForms',
                'aria': 'legalForms',
                'name': 'Documents',
                'display': $rootScope.hasLegals || invitation.helloSign && invitation.helloSign.length > 0
            }, {
                'tab': 'companionInvitation',
                'aria': 'companionInvitation',
                'name': 'Companion Invitation',
                'display': $rootScope.hasCompanions
            }, {
                'tab': 'welcome',
                'aria': 'welcome',
                'name': 'RSVP Confirmation',
                'display': true
            }];

            // Remove ones we don't display
            _.set( $rootScope, 'tabsList', _.compact( _.map( tmpTabs, function cb ( tab ) {
                if ( tab.display ) {
                    return tab;
                }
            } ) ) );
            $rootScope.redirectProperly( invitation );
        }
    } ] );
